import { Badge } from '@/components/ui/Badge'
import { cn } from '@/lib/utils'

interface ComingSoonBadgeProps {
  className?: string
}

export function ComingSoonBadge({ className }: ComingSoonBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'text-[10px] uppercase tracking-wider font-medium opacity-70',
        className,
      )}
    >
      Coming soon
    </Badge>
  )
}
